import { __awaiter, __generator } from "tslib";
import { createBaseTableHeadCellDriver } from '../base-table-head-cell/driver';
export var createSortableTableHeadCellDriver = function (wrapper) {
    var base = createBaseTableHeadCellDriver(wrapper);
    return {
        click: function () { return base.click(); },
        getSortOrder: function () { return __awaiter(void 0, void 0, void 0, function () {
            var isSortable, isAsc, isDesc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, base.hasClass('sortable')];
                    case 1:
                        isSortable = _a.sent();
                        return [4 /*yield*/, base.hasClass('asc')];
                    case 2:
                        isAsc = _a.sent();
                        return [4 /*yield*/, base.hasClass('desc')];
                    case 3:
                        isDesc = _a.sent();
                        return [2 /*return*/, isSortable && isAsc ? 'asc' : isSortable && isDesc ? 'desc' : 'none'];
                }
            });
        }); }
    };
};
//# sourceMappingURL=driver.js.map